import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AppConfig } from './app.config';

@Injectable({
  providedIn: 'root'
})
export class QuesService {

  constructor(public http:HttpClient, public AppConfig:AppConfig) { }
  getQues(reqObj:any, token:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Token '+token
      })
    };
    return this.http.get(this.AppConfig.API_ENDPOINT+'question?mock_test_id='+reqObj.mock_test_id+'&section_obj='+reqObj.section_obj,  httpOptions)
        .pipe(map((response: any) => response));
  }

  getAnalysis(reqObj:any, token:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Token '+token
      })
    };
    return this.http.get(this.AppConfig.LOGIN_ENDPOINT+'student_mock_analysis?mock_id='+reqObj.mock_test_id+'&section_id='+reqObj.section_obj,  httpOptions)
        .pipe(map((response: any) => response));
  }

  getSections(id:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

  

    return this.http.get(this.AppConfig.API_ENDPOINT1+'section_details?mock_test_id='+id,httpOptions)
        .pipe(map((response: any) => response));
  }

  getMocks(paper:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT+'mock_test?category='+paper, httpOptions)
        .pipe(map((response: any) => response));
  }


  submitTest(reqData:any, token:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Token '+token
      })
    };

    return this.http.post(this.AppConfig.LOGIN_ENDPOINT+'submit_mock_test',reqData, httpOptions)
        .pipe(map((response: any) => response));
  }

  getResults(token:any, id:any, sectionid:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Token '+token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT+'mock_results_by_id?mock_id='+id+'&section_id='+sectionid, httpOptions)
        .pipe(map((response: any) => response));

  }

  getSectionDetails(sectionid:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1+'section_get?section_id='+sectionid, httpOptions)
        .pipe(map((response: any) => response));

  }

  getMockMetaData(id:any, section:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/mocktest/v1/section/' + section + '/' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getLeaderBoard(token:any, id:any, sectionid:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Token '+token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT+'all_users_mockresults?mock_id='+id+'&section_id='+sectionid, httpOptions)
        .pipe(map((response: any) => response));

  }


}
